import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BilingualText from '../BilingualText/BilingualText'

const Notes = ({ toggleTab, PerfectScrollbar, toggleChatBox }) => {
  const menu = useSelector(state => state.menu?.data || []);

  const resolveDynamicRoute = (to) => {
    if (!to || typeof to !== 'string') return to;
    try {
      const userContextRaw = localStorage.getItem('userContext');
      if (!userContextRaw) return to;
      const ctx = JSON.parse(userContextRaw);
      return to
        .replace(/{companyId}/g, ctx.companyId || '')
        .replace(/{branchId}/g, ctx.branchId || '')
        .replace(/{assignmentId}/g, ctx.assignmentId || '');
    } catch (e) {
      return to;
    }
  };

  // Build a flattened list of quick links (individual actions) rather than repeating menu structure
  const quickLinks = useMemo(() => {
    if (!menu || menu.length === 0) return [];
    const desired = ['Dashboard', 'Users', 'Customers','Branches'];
    const list = [];
    menu.forEach((item) => {
      if (!desired.includes(item.title)) return;
      // If top-level has a `to`, add it as primary action
      if (item.to) {
        list.push({
          key: item.title.toLowerCase(),
          parent: item.title,
          title: item.title,
          to: item.to,
          icon: item.icon,
          iconType: item.iconType,
        });
      }
      // If it has children, add each child as its own quick link
      if (item.content && item.content.length > 0) {
        item.content.forEach((child) => {
          list.push({
            key: `${item.title.toLowerCase()}-${child.title.toLowerCase().replace(/\s+/g, '-')}`,
            parent: item.title,
            title: child.title,
            to: child.to,
            icon: item.icon,
            iconType: item.iconType,
          });
        });
      }
    });
    return list;
  }, [menu]);

  // Fallback static quick links if menu not ready
  const fallback = [
    { key: 'dashboard', parent: 'Dashboard', title: 'Dashboard', to: '/dashboard', icon: 'dashboard' },
    { key: 'manage-users', parent: 'Users', title: 'Manage User', to: '/company-users', icon: 'people' },
    { key: 'customer-list', parent: 'Customers', title: 'Customer List', to: '/customers', icon: 'person' },
  ];

  const itemsToRender = quickLinks.length > 0 ? quickLinks : fallback;

  return (
    <div id='notes'>
      <div className='card mb-sm-3 mb-md-0 note_card'>
        <div className='card-header chat-list-header'>
          <div>
            <h6 className='mb-1'>Quick Links</h6>
            <p className='mb-0'>Frequently used actions</p>
          </div>
        </div>
        <PerfectScrollbar
          className={`card-body contacts_body p-0 dlab-scroll  ${toggleChatBox ? 'ps ps--active-y' : ''}`}
          id='DZ_W_Contacts_Body2'
        >
          <div className='list-group list-group-flush'>
            {itemsToRender.map((it) => (
              <div key={it.key} className='list-group-item d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>
                  {it.icon ? (
                    <i className={`material-icons${it.iconType === 'outlined' ? '-outlined' : ''} me-2`}>
                      {it.icon}
                    </i>
                  ) : null}
                  <div>
                    <div className='fw-bold' style={{ fontSize: 13 }}>
                      {/* bilingual title */}
                      <BilingualText translationKey={`nav.${it.title.split(' ').map((w,idx) => idx===0? w.toLowerCase(): w.charAt(0).toUpperCase()+w.slice(1)).join('')}`} />
                    </div>
                    <small className='text-muted'>
                      <BilingualText translationKey={`nav.${it.parent.split(' ').map((w,idx) => idx===0? w.toLowerCase(): w.charAt(0).toUpperCase()+w.slice(1)).join('')}`} />
                    </small>
                  </div>
                </div>
                <div>
                  <Link to={resolveDynamicRoute(it.to)} className='btn btn-sm btn-primary'>Open</Link>
                </div>
              </div>
            ))}
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  )
}

export default Notes
